import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import AnalyticsService from 'cio/services/analytics';

export default class SlackController extends Controller {
  @service analytics!: AnalyticsService;

  @action
  onLoad() {
    this.analytics.track('slack', 'settings_viewed', { enabled: true });
  }

  @action
  onErrorLoading() {
    this.analytics.track('slack', 'settings_viewed', { enabled: false });
  }
}
